export default {
    asset_tab_advancedFilters_title: "Filtros Avanzados",
    asset_tab_advancedFilters_clearAll: "Borrar Todo",
    asset_tab_advancedFilters_assetType: "Tipo de Activo",
    asset_tab_advancedFilters_assetSubType: "Subtipo de Activo",
};